
import {stringToDigits} from './formatting';


export function nameValidation(testName) {
	if(testName === null) {
		return "Enter valid name";
	}
	let testLength = testName.trim().length;
	if(testLength <= 0) {
		return "Enter valid name";
	}
	if(testLength > 100) {
		return "100 characters maximum";
	}
	return null;
}

export function usernameValidation(testName) {
	if(testName === null) {
		return "Enter valid username";
	}
	let testLength = testName.trim().length;
	if(testLength <= 0) {
		return "Enter valid username";
	}
	if(testLength > 16) {
		return "16 characters maximum";
	}
	return null;
}

export function emailValidation(testEmail) {
	if(testEmail === null) {
		return "Enter valid email address";
	}
	let testLength = testEmail.trim().length;
	if(testLength <= 0) {
		return "Enter email address";
	}
	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(!re.test(testEmail)) {
  	return "Enter valid email";
  }
	return null;
}

export function phoneValidation(testPhone) {
	if(!testPhone) {
		return "Enter valid phone number";
	}
	let numberString = stringToDigits(testPhone);
	if(numberString.length != 10) {
		return "Phone numbers must have 10 digits";
	}
	return null;
}

export function passwordValidation(testPassword) {
	if(testPassword === null) {
		return "Enter valid password";
	}
	if(testPassword != testPassword.trim()) {
		return "Cannot begin or end with a space";
	}
	let testLength = testPassword.trim().length;
	if(testLength < 8) {
		return "Must be at least 8 characters";
	}
	return null;
}

export function ccNumberValidation(testNumber) {
	if(testNumber === null) {
		return "Enter a valid credit card number";
	}
	let isNum = /^\d+$/.test(testNumber);
	let validLenth = testNumber.length >= 14 && testNumber.length <= 16;
	if(!isNum || !validLenth) {
		return "Enter a valid credit card number";
	}
	return null;
}

export function ccCvcValidation(testCVC) {
	if(testCVC === null) {
		return "Enter a valid CVC";
	}
	let isNum = /^\d+$/.test(testCVC);
	let validLenth = (testCVC.length == 3 || testCVC.length == 4);
	if(!isNum || !validLenth) {
		return "Enter a valid CVC";
	}
	return null;
}

export function idNumberValidation(testIdNumber) {
	if(testIdNumber === null || testIdNumber === '') {
		return "Enter valid identification number";
	}
	let testLength = testIdNumber.trim().length;
	if(testLength <= 0) {
		return "Enter valid identification number";
	}
	if(testLength > 32) {
		return "32 characters maximum";
	}
	return null;
}
